import * as Sentry from "@sentry/browser";
import type { ErrorEvent, EventHint } from "@sentry/core";

import type { WebEnvDetails } from "./getWebEnvDetails.js";

export const sentryInit = (envDetails: WebEnvDetails) => {
  Sentry.init({
    dsn: "https://d76fe52525ca4d4da1180c7a27273a04@sentry.io/1273210",
    release: envDetails.sourceVersion,
    environment: window.location.host,
    integrations: (integrations) =>
      integrations.filter(
        (integration) =>
          // disable auto session tracking
          integration.name !== Sentry.browserSessionIntegration.name,
      ),
    transport:
      envDetails.isUserFacingDeployment ? undefined : (
        () => ({
          send: async () => Promise.resolve({ statusCode: 200 }),
          flush: async () => Promise.resolve(true),
        })
      ),
    beforeSend: (event: ErrorEvent, hint?: EventHint) => {
      if (envDetails.isUserFacingDeployment) {
        return event;
      }

      // eslint-disable-next-line no-console
      console.error(
        hint?.originalException ?? hint?.syntheticException ?? event,
      );
      // returning null will prevent sentry to report the error
      return null;
    },
  });
};
